module.exports = __webpack_public_path__ + "static/media/bountybanner.61372776.png";